import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";
import CircleAlertSvg from "@assets/images/ico_circle_alert.svg";
import CircleCheckSvg from "@assets/images/ico_circle_check.svg";

const tooltipVariants = cva(
  "relative flex w-full list-outside items-center justify-start rounded px-4 py-2 text-center text-sm font-medium text-white",
  {
    variants: {
      variant: {
        error: "bg-red-600",
        complete: "bg-blue-600",
      },
      defaultVariants: {
        variant: "error",
      },
    },
  },
);

export type TooltipProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof tooltipVariants> & {
    children?: React.ReactNode;
  };

const Tooltip = ({ className, variant, children, ...props }: TooltipProps) => {
  return (
    <div className={cn(tooltipVariants({ variant, className }))} {...props}>
      <img src={variant === "error" ? CircleAlertSvg : CircleCheckSvg} width={15} height={15} alt="icon" className="mr-2" />
      <p className="whitespace-pre-line break-keep text-left text-sm text-white">{children}</p>
    </div>
  );
};

export default Tooltip;
